module.exports = __webpack_public_path__ + "img/1121866663.63151145.png";